import { getDataEmissio, getDiaSetmana, removeHtmlTags } from '@portal-internet/core';
import { useState } from 'react';
import { dataResources } from 'utils/constants';
import styles from './properesemissions.module.scss';
const { basePath } = dataResources;

export default function Itememissio(props) {
    const { titolEmissio, data_emissio, codiEspectador, canal, emissora, drets } = props;
    const entradeta = removeHtmlTags(props.entradeta);
    const [isEntradetaDesplegada, setIsEntradetaDesplegada] = useState(false);
    let entradetaTallada = entradeta?.length > 220 ? entradeta?.slice(0, 169) + '...' : entradeta;
    const _showEntradeta = () => {
        return (
            <div className={styles.entradeta}>
                {!isEntradetaDesplegada && (
                    <>
                        {entradetaTallada}
                        {entradeta?.length > 220 && (
                            <button className={styles.botomes} onClick={() => setIsEntradetaDesplegada(true)}>
                                Més
                            </button>
                        )}
                    </>
                )}
                {isEntradetaDesplegada && entradeta}
            </div>
        );
    };

    const _getLogoCanal = () => {
        let logo, label;
        const codiCanal = canal?.id || emissora;

        switch (codiCanal) {
            case 'CAD_ES3':
                logo = 'esport3';
                label = 'Logo Esport3';
                break;
            case 'CAD_C33':
                logo = '33';
                label = 'Logo c33';
                break;
            case 'CAD_SX3':
                logo = 'sx3';
                label = 'Logo Sx3';
                break;
            case 'CAD_324':
                logo = '324';
                label = 'Logo 324';
                break;
            case 'CAD_TV3':
                logo = 'tv3';
                label = 'Logo Tv3';
                break;
            case 'CATRADIO':
                logo = 'cr';
                label = 'Logo CatRadio';
                break;
            case 'CATINFORMACIÓ':
                logo = 'ci';
                label = 'Logo CatInformació';
                break;
            case 'CATCULTURA':
                logo = 'ic';
                label = 'Logo ICat';
                break;
            case 'CATMUSICA':
                logo = 'cm';
                label = 'Logo CatMusica';
                break;
            case 'CAD_BND':
                logo = 'bdtv';
                label = 'Logo Bon dia TV';
                break;
            case 'CAD_TVI':
            case 'CAD_TVC':
                logo = 'tv3cat';
                label = 'Logo TV3cat';
                break;
            default:
                logo = '3cat';
                label = 'Logo 3cat';
                break;
        }

        return (
            <object
                className={`${styles.logo} ${styles[`logo_${logo}`]}`}
                data={basePath + '/_resources/logos/' + logo + '_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                type='image/svg+xml'
                width='124'
                height='40'
                aria-label={label}
                tabIndex='-1'
            >
                <h2>3cat</h2>
            </object>
        );
    };

    return (
        <div className={styles.info2}>
            <div className={styles.emissio}>
                <div className={styles.contLogo}>
                    <div className={styles.logoCanal}>{_getLogoCanal()}</div>
                </div>
                <div className={styles.infoEmissio}>
                    <div className={styles.dataTime}>
                        <time className={styles.data}>
                            {getDiaSetmana(data_emissio)} {getDataEmissio(data_emissio)}
                        </time>
                    </div>
                    {titolEmissio && <h2 className={styles.titolEmissio}>{titolEmissio}</h2>}
                    {_showEntradeta()}
                </div>
            </div>
        </div>
    );
}
